import React from 'react'
import {Modal} from 'common/styleguide/Modal'
import {CTA} from 'common/styleguide/CTA'
import {centeredText, errorMessage} from 'lib/styleguide/base.scss'
import {FormSubmitHack} from 'common/FormSubmitHack'
import fetchJSON from 'lib/fetchJSON'
import {CircleSpinner} from 'common/spinners'
import p from 'prop-types'
import styles from './LoginModal.scss'

// todo: facebook icon
export class LoginModal extends React.PureComponent {
  static propTypes = {
    title: p.string,
    children: p.node,
    redirectTo: p.string
  }

  static defaultProps = {
    title: 'Log In'
  }

  constructor (props) {
    super(props)
    // private instance id used for form IDs
    this._id = Math.random().toString(36).substring(5)
    this.state = {
      email: '',
      password: '',
      error: null,
      loginPending: false
    }
  }

  onEmailChange = e => this.setState({email: e.target.value})

  onPasswordChange = e => this.setState({password: e.target.value})

  onSubmit = (e) => {
    e && e.preventDefault()
    const {email, password} = this.state
    if (!email || !password) {
      this.setState({error: 'Please fill out the email and password fields.', loginPending: false})
      return
    }
    this.setState({loginPending: true})
    fetchJSON('/login.json?apikey=x&version=3', {email, password})
      .then((res) => {
        const redirect = this.props.redirectTo || res.meta.redirect
        redirect
          ? window.location = redirect
          : window.location.reload(true)
      })
      .catch(() => {
        this.setState({error: 'Oops, we were unable to log you in. Please check your email and password and try again.', loginPending: false})
      })
  }

  render () {
    const {title, children, ...props} = this.props
    const {email, password, error, loginPending} = this.state
    const _id = this._id
    const currentPath = this.props.redirectTo || (window.location.pathname + window.location.search + window.location.hash)
    const state = encodeURIComponent(JSON.stringify({attempted_url: currentPath}))
    const fbCallbackURI = encodeURIComponent(`${window.location.origin}/create_facebook_session`)
    const clientId = window.rwgps.config.facebookAppId
    const fbAuthUrl = `https://www.facebook.com/v2.7/dialog/oauth?client_id=${clientId}&redirect_uri=${fbCallbackURI}&state=${state}`

    return (
      <Modal
        title={title}
        subtitle={<span>Need a Ride with GPS account? <a href='/signup'>Create an account</a></span>}
        {...props}>
        {children}
        {error && <p className={errorMessage}>{error}</p>}
        <form onSubmit={this.onSubmit}>
          <FormSubmitHack />
          <div>
            <label htmlFor={'email-' + _id}>Email Address</label>
            <input className={styles.largeText} id={'email-' + _id} autoFocus type='email' value={email} onChange={this.onEmailChange} />
          </div>

          <div>
            <label htmlFor={'password-' + _id}>Password</label>
            <input className={styles.largeText} id={'password-' + _id} type='password' value={password} onChange={this.onPasswordChange} />
          </div>
          <CTA button type='submit' disabled={loginPending} onClick={this.onSubmit}>
            {loginPending
              ? <CircleSpinner light size={12} />
              : 'Log In'}
          </CTA>
        </form>
        <CTA facebook href={fbAuthUrl}>Log In with Facebook</CTA>
        <p className={centeredText}>
          <a href='/users/forgot'>Forgot password?</a>
        </p>
      </Modal>
    )
  }
}
